import React from "react";
import { Coming } from "../../../components/Coming/Coming";

const UserProfile = () => {
  return (
    <div>
      <Coming />
    </div>
  );
};

export default UserProfile;
